import * as actionTypes from "./actionTypes";
import * as eventTpyes from "./eventTypes";
import initialState from "reducers/initialState";

const simulatorAssetsReducer = (state = initialState.simulatorData, action) => {
  switch (action.type) {
    case actionTypes.LOAD_SIMULATOR_ASSET_STARTED:
      return {
        ...state,
        assets: {
          data: [],
          loading: true,
          loaded: false
        }
      };
    case eventTpyes.SIMULATOR_ASSETS_NUMBER_COMPUTED: {
      const { assets, totalCount } = action.event.eventBody;
      return {
        ...state,
        assets: {
          ...state.assets,
          totalCount,
          data: [...assets]
        }
      };
    }
    case eventTpyes.SIMULATOR_ASSETS_LOADED: {
      const { loadedAssets } = action.event.eventBody;
      return {
        ...state,
        assets: {
          ...state.assets,
          data: [
            ...state.assets.data.map(asset =>
              Object.assign({}, asset, {
                assetHierarchyName: loadedAssets.find(x => x.assetHierarchyId === asset.assetHierarchyId)
                  .assetHierarchyName
              })
            )
          ]
        }
      };
    }
    case actionTypes.LOAD_SIMULATOR_ASSET_SUCCEEDED:
      return {
        ...state,
        assets: {
          ...state.assets,
          loading: false,
          loaded: true
        }
      };
    case actionTypes.LOAD_SIMULATOR_PRODUCTS_STARTED:
      return {
        ...state,
        products: {
          data: [],
          loading: true,
          loaded: false
        }
      };
    case eventTpyes.GENERATE_SIMULATIONS_IN_MEMORY_COMPLETED: {
      const { simulations, ...request } = action.event.eventBody;
      return {
        ...state,
        products: {
          ...state.products,
          request: request,
          data: [...simulations]
        }
      };
    }
    case actionTypes.LOAD_SIMULATOR_PRODUCTS_SUCCEEDED: {
      return {
        ...state,
        products: {
          ...state.products,
          loading: false,
          loaded: true
        }
      };
    }
    case actionTypes.LOAD_SIMULATOR_PRODUCTS_FAILED:
      return {
        ...state,
        products: {
          ...state.products,
          loading: false,
          loaded: false
        }
      };
    case actionTypes.RESET_SIMULATOR_ASSETS: {
      return initialState.simulatorData;
    }
    case actionTypes.SAVE_OFFER_FROM_SIMULATOR_STARTED:
      return {
        ...state,
        saving: true
      };
    case actionTypes.SAVE_OFFER_FROM_SIMULATOR_SUCCEEDED:
      return {
        ...state,
        saving: false
      };
    case actionTypes.SAVE_OFFER_FROM_SIMULATOR_FAILED:
      return {
        ...state,
        saving: false
      };
    default:
      return state;
  }
};

export default simulatorAssetsReducer;
